module.exports = __webpack_public_path__ + "static/img/medicinal-inhaler_256.89e89fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medicinal-inhaler_256.png
// module id = aDcY
// module chunks = 0